export default __webpack_public_path__ + "static/media/ic_barcode.3ec2ab52.svg";